// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderSummaryView__copylinkbutton__vFbq3 {
  background-color: #e6e6e6;
  border-color: #e6e6e6;
  color: #000;
  margin-right: 5px;
}

.OrderSummaryView__copylinkbutton__vFbq3:hover {
  background-color: #e6e6e6;
  border-color: #606af9;
  color: #000;
}

.OrderSummaryView__openintabbutton__Irc4X {
  background-color: #fc0;
  border-color: #fc0;
  color: #000;
}

.OrderSummaryView__openintabbutton__Irc4X:hover {
  background-color: #fdedb0;
  border-color: #fc0;
  color: #000;
}`, "",{"version":3,"sources":["webpack://./src/apps/orders/OrderSummaryView.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;EACA,qBAAA;EACA,WAAA;AACF;;AAEA;EACE,sBAAA;EACA,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;AACF","sourcesContent":[".copylinkbutton {\n  background-color: #e6e6e6;\n  border-color: #e6e6e6;\n  color: #000;\n  margin-right: 5px;\n}\n\n.copylinkbutton:hover {\n  background-color: #e6e6e6;\n  border-color: #606af9;\n  color: #000;\n}\n\n.openintabbutton {\n  background-color: #fc0;\n  border-color: #fc0;\n  color: #000;\n}\n\n.openintabbutton:hover {\n  background-color: #fdedb0;\n  border-color: #fc0;\n  color: #000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"copylinkbutton": `OrderSummaryView__copylinkbutton__vFbq3`,
	"openintabbutton": `OrderSummaryView__openintabbutton__Irc4X`
};
export default ___CSS_LOADER_EXPORT___;
